<template>
    <div class="card__text" :class="[sizeString ? 'text-' + sizeString : '', {'text-center': center, 'text-right': right}]">
        <div class="w-full" :class="{'stretch-layout': fill}">
            <slot/>
        </div>
    </div>
</template>

<script>
import Sizeable from "../../mixins/Sizeable";
    import Alignable from "../../mixins/Alignable";

    export default {
        name: "CardText",

        mixins: [Sizeable, Alignable],

        props: {
            // Whether to stretch the content over the full available height of the parent
            fill: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style>
/*********************
  Inputs
**********************/
/*********************
  Typography
**********************/
/*********************
  Inputs
**********************/
/*********************
  Shadows
**********************/
/*********************
  Layout
**********************/
/*********************
  Card
**********************/
/*********************
  Opacity
**********************/
.card .card__subtitle + .card__text, .card .card__title + .card__text {
  padding-top: 0;
}
.card .card__text {
  color: #465050;
  display: flex;
  flex: 1 1 auto;
  max-width: 100%;
  padding: 20px 24px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
}
@media (max-width: 1023px) {
  .card .card__text {
    padding: 16px;
  }
}
.card.card-small .card__text {
  padding: 16px;
}
.card.card-small .card__subtitle + .card__text, .card.card-small .card__title + .card__text {
  padding-top: 0;
}
.card.card-x-small .card__text {
  padding: 12px;
}
@media (max-width: 1023px) {
  .card.card-x-small .card__text {
    padding: 8px;
  }
}
.card.card-x-small .card__subtitle + .card__text, .card.card-x-small .card__title + .card__text {
  padding-top: 0;
}
.card.is-dark .card__text {
  color: #ffffff;
}
</style>